import { IconStockCard, type IconStockCardProps } from "@fero/components";
import { Stack } from "@mui/material";
import {
  snTopLevelUnitType,
  type TopLevelUnitType,
} from "adl-gen/ferovinum/app/db";
import React, { useMemo } from "react";
import { getFormLabelForUnionField } from "utils/adl-utils";
import type { StockDataDisplayInfo } from "./stock-listing-table";

interface Props {
  stockType: TopLevelUnitType;
  stockData: StockDataDisplayInfo;
}

export const IconStockCards = ({ stockType, stockData }: Props) => {
  // Next step should be removing the 'warning' and 'error' cards as they are superceded by the
  // expiring stock page.
  const stockCards: IconStockCardProps[] = useMemo(() => {
    const stockTypeLabel = getFormLabelForUnionField(
      snTopLevelUnitType,
      stockType,
    );
    return [
      {
        state: "info",
        title: `Total ${stockTypeLabel}`,
        number: stockData.totalUnsoldQuantity.value,
      },
      {
        state: "warning",
        title: `${stockTypeLabel} approaching repurchase deadlines`,
        number: Math.floor(
          stockData.withSecondHalfProgress
            .quantityAvailableInCompulsorySaleStage.value +
            stockData.withSecondHalfProgress.quantityAvailableInFinalStage
              .value,
        ),
      },
      {
        state: "error",
        title: `${stockTypeLabel} very close to repurchase deadlines`,
        number: Math.floor(
          stockData.withEndingProgress.quantityAvailableInCompulsorySaleStage
            .value +
            stockData.withEndingProgress.quantityAvailableInFinalStage.value +
            stockData.withEndedProgress.quantityAvailableInCompulsorySaleStage
              .value +
            stockData.withEndedProgress.quantityAvailableInFinalStage.value,
        ),
      },
    ];
  }, [stockData, stockType]);

  return (
    <Stack spacing={12} direction="row">
      {stockCards
        .filter((card) => card.number > 0)
        .map((card) => (
          <React.Fragment key={card.title}>
            <IconStockCard {...card} />
          </React.Fragment>
        ))}
    </Stack>
  );
};
